import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: [],
  randomThree: [],
  pengumuman: {}
}

// getters
const getters = {
  allPengumuman: state => state
}

// actions
const actions = {
  getAllPengumuman({ commit }) {
    api.get('/v1/pengumuman')
      .then(response => {
        let responseData = response.data
        commit(types.PENGUMUMAN_RECIEVE, { responseData })
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  },
  getOnePengumuman({ commit }, id) {
    api.get(`/v1/pengumuman/${id}`)
      .then(response => {
        let responseData = response.data
        commit(types.ONE_PENGUMUMAN_RECEIVE, { responseData })
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.PENGUMUMAN_RECIEVE](state, { responseData }) {
    state.all = responseData.data
    state.randomThree = [
      state.all.length > 0 ? state.all[0] : null,
      state.all.length > 1 ? state.all[1] : null,
      state.all.length > 2 ? state.all[2] : null
    ]
  },
  [types.ONE_PENGUMUMAN_RECEIVE](state, { responseData }) {
    state.pengumuman = responseData.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pengumuman.js